import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";

// // // //

export const JURISDICTION_COUNTRY_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: "jurisdiction_country",
    label: "Jurisdiction",
    sortsOn: AssetColumns.jurisdictionCountryName,
    type: ColumnTypes.string,
    width: 150,
    render: (item) => {
        if (!item.isAsset) return null;

        const name = item.jurisdiction_country?.name;
        if (!name) return <Emdash />;

        return <span className="dg-overflow">{name}</span>;
    },
};
